<template>
  <BaseButton
    isSmall
    has-icon-right
    :disabled="state !== 'idle' || !keywords.length"
    :isLoading="state === 'loading'"
    @click.native="transform()"
  >
    <span>{{ $t('actions.transform') }}</span>
    <span :class="['keyword-transform__check', { 'is-visible': state === 'done' }]" aria-hidden="true">
      <BaseIcon name="check" :size="12" />
    </span>
  </BaseButton>
</template>

<script>
import axios from 'axios';
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import { keywordsService } from '@/services/keywords.service';
import { buildKeywords } from '@/util/keywords-util';

// Rewrites the keywords typed one per line into the keyword syntax (v-model on the text), for the user to review
// before adding them. Done until the text is edited.
export default {
  name: 'KeywordTransformButton',
  components: {
    BaseButton,
    BaseIcon,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    // Where the keywords will be searched: 'tenders' when absent, or 'documents'
    target: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      state: 'idle',
      transformedText: null,
    };
  },
  computed: {
    keywords() {
      return buildKeywords(this.value || '');
    },
  },
  watch: {
    value(text) {
      if (this.state === 'done' && text !== this.transformedText) this.state = 'idle';
    },
  },
  methods: {
    async transform() {
      if (this.state !== 'idle' || !this.keywords.length) return;

      this.state = 'loading';
      try {
        const transformed = await keywordsService.transformKeywords(this.keywords, this.target);
        // An empty answer would wipe what the user typed
        if (!transformed.length) {
          this.state = 'idle';
          this.$toast.error(this.$t('toast.error'));
          return;
        }
        this.transformedText = transformed.join('\n');
        this.state = 'done';
        this.$emit('input', this.transformedText);
      } catch (error) {
        this.state = 'idle';
        if (!axios.isCancel(error)) this.$toast.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
.keyword-transform__check {
  display: inline-flex;
  align-items: center;
  height: 1em;
  width: 0;
  margin-left: 0;
  overflow: hidden;
  opacity: 0;
  transition: width 180ms ease, margin-left 180ms ease, opacity 160ms ease;

  &.is-visible {
    width: 22px;
    margin-left: 8px;
    opacity: 1;
  }
}
</style>
